import HTTPClient from './http-client';

const END_POINT = '/location';

const options = {
    cache: {
        maxAge: 24 * 60 * 60 * 1000,
        exclude: { query: false }
    }
}

const loadLocations = async ({customer_id, basin_id, location_id}) => {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    let url = `${END_POINT}?`;

    if(customer_id){
      url += `&customer_ids=${customer_id}`;
    }

    if(basin_id){
      url += `&basin_ids=${basin_id}`;
    }

    if(location_id){
      url += `&location_ids=${location_id}`;
    }

    return api.get(url, options);
}

export {
  loadLocations,
}
